import { getCurrentUser } from "@voix/composables/queries/useQueryCurrentUser";
import { useUserStore } from "@voix/store/userStore";
export function useVoixUserAuth() {
  const checkPermission = (user, permission) => {
    if (!user || !Array.isArray(user.all_permissions))
      return false;
    const foundPermission = user.all_permissions.find((userPermission) => {
      if (userPermission.name.slice(-1) === "*" && userPermission.name.slice(-2, -1) === ".") {
        const permissionParts = permission.split(".");
        const userPermissionParts = userPermission.name.split(".");
        if (userPermissionParts[0] === permissionParts[0])
          return true;
      }
      return userPermission.name.indexOf(permission) === 0;
    });
    if (foundPermission)
      return true;
    return false;
  };
  const checkUserPermissions = async (permissions) => {
    const userStore = useUserStore();
    if (!userStore.currentUser)
      await getCurrentUser();
    const currentUser = userStore.currentUser;
    if (!currentUser)
      return false;
    if (typeof permissions === "object") {
      for (const permission of permissions) {
        if (checkPermission(currentUser, permission))
          return true;
      }
      return false;
    }
    return checkPermission(currentUser, permissions);
  };
  return { checkPermission, checkUserPermissions };
}
